export default __webpack_public_path__ + "static/desert-xs-e43d5a20e97ed663153f5b6a9b3cee7f.png";